<pn-dialog
    [closable]="false"
    [closeOnEscape]="false"
    [modal]="true"
    [visible]="isConnecting() || hasError()"
>
    <ng-template pnDialogTemplate="headless">
        <div class="connection-check">
            @if (hasError()) {
                <pn-icon name="circle-x" size="xl" class="error-icon" />
                <span>{{ errorMessageKey() | translate }}</span>
                <pn-button icon="rotate-ccw" [text]="'splash.retry' | translate" severity="secondary" (clicked)="retry.emit()" />
            } @else {
                <pn-progress-spinner />
                <span>{{ 'splash.connecting' | translate }}</span>
            }
        </div>
    </ng-template>
</pn-dialog>
